import React from 'react'
import {Control, Controller, FieldErrors, FieldValues, Path} from 'react-hook-form'
import {
  formatAustralianAbnInput,
  normalizeAustralianAbn,
} from '../../application/component/renter-home/renterHomeUtils'
import {getFieldError} from './getFieldError'

type AbnInputProps<T extends FieldValues> = {
  name: Path<T>
  label?: string
  placeholder?: string
  required?: boolean
  control: Control<T>
  errors?: FieldErrors<T>
  className?: string
  inputClassName?: string
  disabled?: boolean
  helperText?: string
}

export const AbnInput = <T extends FieldValues>({
  name,
  label,
  placeholder = '12 345 678 901',
  control,
  required = false,
  errors,
  className = '',
  inputClassName = '',
  helperText = '',
  disabled = false,
}: AbnInputProps<T>) => {
  const error = getFieldError(errors, name)

  return (
    <div className={`mb-5 ${className}`.trim()}>
      {label && (
        <label className='form-label fw-semibold' htmlFor={String(name)}>
          {label} {required && <span className='text-danger'>*</span>}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <input
            id={String(name)}
            type='tel'
            inputMode='numeric'
            autoComplete='off'
            placeholder={placeholder}
            className={`form-control ${inputClassName} ${error ? 'is-invalid' : ''}`.trim()}
            disabled={disabled}
            name={field.name}
            ref={field.ref}
            onBlur={() => {
              field.onChange(normalizeAustralianAbn(String(field.value ?? '')))
              field.onBlur()
            }}
            value={formatAustralianAbnInput(String(field.value ?? ''))}
            onChange={(event) => {
              field.onChange(normalizeAustralianAbn(event.target.value))
            }}
          />
        )}
      />
      {helperText && <small className='text-muted d-block mt-1 fs-6'>{helperText}</small>}
      {error && <div className='text-danger mt-1'>{error.message}</div>}
    </div>
  )
}
